import { render } from "./CertificateButton.vue?vue&type=template&id=2397fd36&scoped=true"
import script from "./CertificateButton.vue?vue&type=script&lang=js"
export * from "./CertificateButton.vue?vue&type=script&lang=js"

import "./CertificateButton.vue?vue&type=style&index=0&id=2397fd36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2397fd36"]])

export default __exports__